import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import * as React from 'react';
import { Mail, Phone, Send, Camera, FileText, Copy } from 'lucide-react';
import { Badge, Button, Tooltip, toast } from '@wit-support/ui';
import { cn } from './lib/cn.js';
const ICON_FOR_KIND = {
    email: Mail,
    gmail_address: Mail,
    phone: Phone,
    whatsapp_phone: Phone,
    telegram_user_id: Send,
    instagram_user_id: Camera,
    web_form_session: FileText,
};
async function copy(value) {
    try {
        await navigator.clipboard.writeText(value);
        toast.success('Copied');
    }
    catch {
        toast.error('Failed to copy');
    }
}
/**
 * contact_identity display: icon + truncated value + copy-to-clipboard button
 * that appears on hover / focus.
 */
export const IdentityChip = React.forwardRef(({ identity, className }, ref) => {
    const Icon = ICON_FOR_KIND[identity.kind] ?? FileText;
    return (_jsxs(Badge, { ref: ref, variant: "neutral", size: "sm", className: cn('group inline-flex max-w-full items-center gap-1.5 pr-1 font-mono', className), children: [_jsx(Icon, { className: "h-3 w-3 shrink-0", "aria-hidden": "true" }), _jsx("span", { className: "min-w-0 break-all", title: identity.value, children: identity.value }), _jsx(Tooltip.Provider, { children: _jsxs(Tooltip.Root, { children: [_jsx(Tooltip.Trigger, { asChild: true, children: _jsx(Button, { type: "button", variant: "ghost", size: "sm", onClick: () => void copy(identity.value), "aria-label": `Copy ${identity.kind}`, className: "h-5 w-5 p-0 opacity-0 transition-opacity group-hover:opacity-100 group-focus-within:opacity-100", children: _jsx(Copy, { className: "h-3 w-3", "aria-hidden": "true" }) }) }), _jsx(Tooltip.Content, { children: "Copy" })] }) })] }));
});
IdentityChip.displayName = 'IdentityChip';
//# sourceMappingURL=identity-chip.js.map